import { createApi } from "@reduxjs/toolkit/query/react";

import { createCustomFetchBaseQuery } from "../baseQuery";


export const bannerApi = createApi({
    reducerPath: "banner",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['banner'],
    endpoints: (builder) => ({
        getBanners: builder.query({
            query: ({ page, search,status,limit }) => {
                let url = `banners?page=${page+1}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ['banner'],
        }),
        createBanner: builder.mutation({
            query: (data) => ({
                url: `banners`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['banner'],
        }),
        updateBanner: builder.mutation({
            query: ({ id, data }) => ({
                url: `banners/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['banner'],
        }),
        deleteBanner: builder.mutation({
            query: (id) => ({
                url: `banners/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['banner'],
        }),
    }),
});

export const {
    useGetBannersQuery,
    useCreateBannerMutation,
    useUpdateBannerMutation,
    useDeleteBannerMutation,
} = bannerApi;